// FavoriteFeed.jsx
import React from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import { Grid, Calendar } from 'lucide-react';
import AccountPhoto from "./AccountPhoto.jsx";
import PhotoModal from "./PhotoModal.jsx";

class FavoriteFeed extends React.Component {
  constructor(props) {
    super(props);
    // Добавляем is_liked более простым способом
    var initialData = props.data.map(function(item) {
      var newItem = Object.assign({}, item);
      newItem.is_liked = true; // Все элементы в избранном имеют лайк
      return newItem;
    });
    
    this.state = { 
      data: initialData,
      modalOpen: false,
      currentPhotoIndex: null,
      viewMode: 'grid'
    };
  }

  handleLikeChange = (photoId, isLiked) => {
    if (!isLiked) {
      this.setState(function(prevState) {
        return {
          data: prevState.data.filter(function(item) {
            return item.id !== photoId;
          }),
          modalOpen: prevState.modalOpen && prevState.data[prevState.currentPhotoIndex].id !== photoId,
          currentPhotoIndex: prevState.currentPhotoIndex
        };
      }, function() {
        if (this.state.modalOpen && this.state.data.length > 0) {
          var newIndex = Math.min(this.state.currentPhotoIndex, this.state.data.length - 1);
          this.setState({ currentPhotoIndex: newIndex });
        }
      });
    }
  }

  openModal = (photoId) => {
    var index = this.state.data.findIndex(function(item) {
      return item.id === photoId;
    });
    
    this.setState({
      modalOpen: true,
      currentPhotoIndex: index
    });
    document.body.style.overflow = 'hidden';
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
      currentPhotoIndex: null
    });
    document.body.style.overflow = 'auto';
  }

  navigatePhoto = (direction) => {
    var self = this;
    this.setState(function(prevState) {
      var newIndex = prevState.currentPhotoIndex + direction;
      
      if (newIndex < 0) {
        newIndex = self.state.data.length - 1;
      } else if (newIndex >= self.state.data.length) {
        newIndex = 0;
      }
      
      return { currentPhotoIndex: newIndex };
    });
  }

  toggleViewMode = () => {
    this.setState(function(prevState) {
      return {
        viewMode: prevState.viewMode === 'grid' ? 'timeline' : 'grid'
      };
    });
  }

  renderGridView() {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-1 mb-8">
        {this.state.data.map(function(item) {
          return (
            <AccountPhoto 
              key={item.id} 
              data={item}
              favorite={true}
              onPhotoClick={this.openModal}
              onLikeChange={this.handleLikeChange}
            />
          );
        }, this)}
      </div>
    );
  }

  renderTimelineView() {
    // Группируем фото по дате лайка
    var groupedByDate = _.groupBy(this.state.data, function(item) {
      var date = new Date(item.liked_at);
      return date.toLocaleDateString('ru-RU', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    });

    var self = this;
    return (
      <div className="space-y-8 mb-8">
        {Object.keys(groupedByDate).map(function(date) {
          var items = groupedByDate[date];
          return (
            <div key={date} className="space-y-4">
              <div className="sticky top-0 bg-slate-900/95 backdrop-blur-sm z-10 py-2">
                <h3 className="text-sm font-medium text-slate-400">{date}</h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-1">
                {items.map(function(item) {
                  return (
                    <AccountPhoto 
                      key={item.id} 
                      data={item}
                      favorite={true}
                      onPhotoClick={self.openModal}
                      onLikeChange={self.handleLikeChange}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    var totalItems = this.state.data ? this.state.data.length : 0;

    return (
      <div className="w-full px-4 mt-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <i className="fas fa-heart text-rose-500"></i>
              <h2 className="text-lg font-medium text-slate-200">Избранное</h2>
            </div>
            
            <button
              onClick={this.toggleViewMode}
              className="p-2 text-slate-400 hover:text-slate-200 hover:bg-slate-800/50 rounded-lg transition-colors"
            >
              {this.state.viewMode === 'grid' ? (
                <Calendar className="w-5 h-5" />
              ) : (
                <Grid className="w-5 h-5" />
              )}
            </button>
          </div>
          <div className="text-xs text-slate-500">
            {totalItems} {totalItems === 1 ? 'публикация' : 'публикаций'}
          </div>
        </div>

        {totalItems > 0 ? (
          this.state.viewMode === 'grid' ? 
            this.renderGridView() : 
            this.renderTimelineView()
        ) : (
          <div className="text-center py-12">
            <div className="text-2xl text-slate-500 mb-2">
              <i className="far fa-heart"></i>
            </div>
            <p className="text-sm text-slate-400">В избранном пока ничего нет</p>
          </div>
        )}

        {/* Modal */}
        {this.state.modalOpen && this.state.currentPhotoIndex !== null && 
         this.state.data[this.state.currentPhotoIndex] && (
          <PhotoModal 
            photo={this.state.data[this.state.currentPhotoIndex]}
            account={this.state.data[this.state.currentPhotoIndex].account}
            favorite={true}
            onClose={this.closeModal}
            onNavigate={this.navigatePhoto}
          />
        )}
      </div>
    );
  }
}

FavoriteFeed.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    liked_at: PropTypes.string.isRequired,
    account: PropTypes.shape({
      nickname: PropTypes.string.isRequired,
      avatar: PropTypes.shape({
        url: PropTypes.string
      })
    }).isRequired
  })).isRequired
};

export default FavoriteFeed;